"use client";

import { useEffect } from "react";
import { getGoogleAdsSignupConversion } from "@/lib/actions/google-ads-actions";
import { hasGoogleAdsConsent, loadGoogleAds, sendGoogleAdsSignup } from "@/lib/analytics/google-ads-browser";
const RETRY_DELAYS_MS = [1000, 2000, 4000];
export function useGoogleAdsConversion(userId: string | undefined, confirmedAt: string | undefined, consent: boolean) {
  useEffect(() => {
    if (!consent || !hasGoogleAdsConsent()) return;
    let cancelled = false;
    let retry = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const eligible = () => !cancelled && hasGoogleAdsConsent();
    async function attempt() {
      if (!eligible()) return;
      try {
        await loadGoogleAds();
        if (!eligible() || !userId || !confirmedAt) return;
        const conversion = await getGoogleAdsSignupConversion();
        if (eligible() && conversion) sendGoogleAdsSignup(conversion.transactionId);
      } catch {
        // Retry only failures, not a legitimate null eligibility result.
        // No overlapping attempts; consent/identity changes cancel this cycle.
        if (eligible() && retry < RETRY_DELAYS_MS.length) {
          timer = setTimeout(() => void attempt(), RETRY_DELAYS_MS[retry++]);
        }
      }
    }
    void attempt();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [userId, confirmedAt, consent]);
}